import { Component, Input, Output, EventEmitter, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'toggle-arrow-btn',
  templateUrl: './toggle-arrow-btn.component.html',
  styleUrls: ['./toggle-arrow-btn.component.less'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class ToggleArrowBtnComponent {
  @Input() direction: 'left' | 'right' = 'left';
  @Input() size = 32;
  @Input() ariaLabel = 'Toggle Sidebar';
  @Input() expanded = false; // <-- for aria-expanded

  @Output() clicked = new EventEmitter<void>();
  @Input() autId: string;

  onClick() {
    this.clicked.emit();
  }
}
